class ModalEvent {

	// state changes

	// commands

	get OPEN() { return 'open'; }
	get CLOSE() { return 'sliderVideo'; }

}

export default new ModalEvent();
